<template>
  <div>
    <div class="dont-print">
      <div>
        <button :class="(localDateKey || 'month').toLowerCase() === 'month' ? 'selected' : ''" @click="setDateKey('Month')">Month</button>
        <button :class="(localDateKey || 'month').toLowerCase() === 'week' ? 'selected' : ''" @click="setDateKey('Week')">Week</button>
        <button :class="(localDateKey || 'month').toLowerCase() === 'day' ? 'selected' : ''" @click="setDateKey('Day')">Day</button>
      </div>
      <div>
      </div>
      <div>
        <button @click="previous()">Previous {{localDateKey}}</button>
        <button @click="next()">Next {{localDateKey}}</button>
      </div>
    </div>
    <p>Selected data from {{D(timestamps.from)}} To From {{D(timestamps.to)}}</p>
  </div>


</template>

<script>
import formatDataMixin from '@/mixins/formatDataMixin.js'

export default {
  name: 'GenericDatePeriodSelector',
  inject: ['page'],
  // props:[
  //   'storeName',
  //   'dateKey',
  //   'willLoadData',
  // ],
  props:{
    'storeName':{},
    'dateKey':{default:'Month',type: String},
    'willLoadData':{},
  },
  data(){
    return {
      localDateKey:'Month',
    }
  },
  mixins : [formatDataMixin],
  computed:{
    store(){return this.page.$refs[this.storeName]},
    timestamps(){ return this.store.timestamps},
    // dateKey(){ return this.timestamps.dateKey},
  },
  created(){
    this.localDateKey = this.dateKey;
    this.timestamps.dateKey = this.localDateKey;
  },
  mounted(){
    if(this.willLoadData === true){
      this.$set(this.timestamps, 'from', moment(this.timestamps.from).startOf(this.timestamps.dateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.$set(this.timestamps, 'to', moment(this.timestamps.from).endOf(this.timestamps.dateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.store.loadData();
    }
  },
  methods:{
    movePeriod(direction){
      this.$set(this.timestamps, 'from', moment(this.timestamps.from)[direction](1, this.localDateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.$set(this.timestamps, 'to', moment(this.timestamps.from).endOf(this.localDateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.store.loadData();
    },
    previous(){this.movePeriod('subtract')},
    next(){this.movePeriod('add')},
    setDateKey(key){
      this.timestamps.dateKey = key
      this.localDateKey = key
      this.$set(this.timestamps, 'from', moment(this.timestamps.from).startOf(this.localDateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.$set(this.timestamps, 'to', moment(this.timestamps.from).endOf(this.localDateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.store.loadData();
    }
  }
  

}
</script>

<style scoped>
.selected{
  /* opacity: 0.6; */
  background-color: darkgray;
}
</style>